var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ConsumerInfoValidator, isConsumerCountryCodeValid } from "../ConsumerInfoValidator";
import { CONSUMER_FIRST_NAME_LENGTH, CONSUMER_LAST_NAME_LENGTH, getConsumerValidationProfile, } from "../ConsumerValidationProfiles";
import { DcfSdkEnumsObj } from "../../../enums/DcfSdkEnum";
var LEGACY_IDENTITY_TYPES = {
    EMAIL: "EMAIL_ADDRESS",
    EMAIL_ADDRESS: "EMAIL_ADDRESS",
    MOBILE_NUMBER: "MOBILE_PHONE_NUMBER",
    MOBILE_PHONE_NUMBER: "MOBILE_PHONE_NUMBER",
};
var normalizeIdentityType = function (identityType) {
    return identityType ? LEGACY_IDENTITY_TYPES[identityType] : undefined;
};
var resolveConsumerIdentity = function (value) {
    var _a, _b, _c, _d, _e;
    var currentType = normalizeIdentityType((_a = value.consumerIdentity) === null || _a === void 0 ? void 0 : _a.identityType);
    var legacyType = normalizeIdentityType((_b = value.consumerIdentity) === null || _b === void 0 ? void 0 : _b.type);
    if ((((_c = value.consumerIdentity) === null || _c === void 0 ? void 0 : _c.identityType) && !currentType) || (((_d = value.consumerIdentity) === null || _d === void 0 ? void 0 : _d.type) && !legacyType)) {
        return {
            errors: [{ field: "consumerIdentity", code: "UNSUPPORTED_IDENTITY_TYPE" }],
        };
    }
    if (currentType && legacyType && currentType !== legacyType) {
        return {
            errors: [{ field: "consumerIdentity", code: "CONFLICTING_IDENTITY_TYPES" }],
        };
    }
    var identityType = currentType || legacyType || "EMAIL_ADDRESS";
    var identityValue = identityType === "EMAIL_ADDRESS"
        ? value.emailAddress
        : "".concat(value.mobileNumber.countryCode).concat(value.mobileNumber.phoneNumber);
    return {
        value: {
            identityProvider: ((_e = value.consumerIdentity) === null || _e === void 0 ? void 0 : _e.identityProvider) || "SRC",
            identityType: identityType,
            identityValue: identityValue,
        },
        errors: [],
    };
};
var VisaConsumerMapper = /** @class */ (function () {
    function VisaConsumerMapper() {
    }
    VisaConsumerMapper.map = function (value, context) {
        if (context === void 0) { context = {}; }
        var billingCountryAvailable = isConsumerCountryCodeValid(context.billingAddressCountryCode);
        var validationProfile = context.useNetworkValidationProfile
            ? getConsumerValidationProfile(DcfSdkEnumsObj.VISA)
            : { firstNameLength: CONSUMER_FIRST_NAME_LENGTH, lastNameLength: CONSUMER_LAST_NAME_LENGTH };
        var validationErrors = ConsumerInfoValidator.validate(value, {
            countryRequired: !billingCountryAvailable,
            firstNameLength: validationProfile.firstNameLength,
            lastNameLength: validationProfile.lastNameLength,
        });
        var consumerIdentity = resolveConsumerIdentity(value);
        var errors = validationErrors.concat(consumerIdentity.errors);
        if (errors.length || !consumerIdentity.value) {
            return { errors: errors };
        }
        var visaConsumer = __assign(__assign({ firstName: value.firstName, lastName: value.lastName, emailAddress: value.emailAddress, mobileNumber: {
                countryCode: value.mobileNumber.countryCode,
                phoneNumber: value.mobileNumber.phoneNumber,
            }, consumerIdentity: consumerIdentity.value }, (value.countryCode ? { countryCode: value.countryCode } : {})), (value.nationalIdentifier ? { nationalIdentifier: value.nationalIdentifier } : {}));
        return {
            value: visaConsumer,
            errors: [],
        };
    };
    return VisaConsumerMapper;
}());
export { VisaConsumerMapper };
